export const AncillaryCost = 'AncillaryCost';
export const AssociateAttendee = AncillaryCost + "/AssociateAttendee"
export const GetAssociatedAttendee = AncillaryCost + "/SearchAssociatedAttendee"
